import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppOneSignalService {


  constructor(private http: HttpClient) {
  }

  async sendNotification(data: any) {
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
      "Authorization": "Basic NWI3MDM2ZDMtMjM1Ni00N2JlLTk4YzItNTQ4MzBhZTU5ZDJj"
    };
    
    const url = 'https://onesignal.com/api/v1/notifications';

    var options = {
      headers: headers
    };
    this.http.post(url, data, options).subscribe( (response) => {
      console.log(response);
    });
    
    // var req = this.http.post(options, function(res) {  
    //   res.on('data', function(data) {
    //     this.snack.openSnackBar(err.message);"Response:");
    //     this.snack.openSnackBar(err.message);JSON.parse(data));
    //   });
    // });
    
    // req.on('error', function(e) {
    //   this.snack.openSnackBar(err.message);"ERROR:");
    //   this.snack.openSnackBar(err.message);e);
    // });
    
    // req.write(JSON.stringify(data));
    // req.end();
  }
}